import { Box } from '@chakra-ui/react';

interface Props {
  placeholder?: string;
}

function NoDocPlaceholder({ placeholder = 'No documents required' }: Props) {
  return (
    <Box
      data-selector="no-documents-placeholder"
      bgColor={'chakra-subtle-bg'}
      px={6}
      py={6}
      my={3}
      borderRadius={'lg'}
      fontSize={'lg'}
      lineHeight={6}
    >
      {placeholder}
    </Box>
  );
}

export default NoDocPlaceholder;
